import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18n';
import classNames from 'classnames';
import ExistingResourceForm from '../CarePlans/ResourceSection/ExistingResourceForm';

const i18nOptsTags = { scope: 'tags' };

class LinkResources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resources: [],
      filteredModalResources: [],
      resourceSelectionStates: {},

      ...this.setInitialState(),
    };
  }

  get initialState() {
    return {
      ...this.setInitialState(),
    };
  }

  setInitialState = () => {
    const { placeResources, adHocResources } = this.props.resources;
    const { libraryVideos, selectedVideos } = this.props;

    const adHoc = adHocResources ? adHocResources.map((res) => ({ ...res, isAdHoc: true })) : [];
    const nonAdHoc = placeResources ? placeResources.map((res) => ({ ...res, isAdHoc: false })) : [];

    const videos = libraryVideos ? libraryVideos.map((vid) => ({
      ...vid,
      id: `VIDEO_${vid.uuid}`,
      link: vid.url,
      isAdHoc: false,
      resourceType: 'video'
    })) : [];

    const resourceSelectionStates = {};
    nonAdHoc.forEach((res) => {
      resourceSelectionStates[res.id] = false;
    });
    adHoc.forEach((res) => {
      resourceSelectionStates[res.id] = false;
    });
    videos.forEach((vid) => {
      resourceSelectionStates[vid.id] = false;
    });

    this.props.selectedResources.forEach((res) => {
      resourceSelectionStates[res.id] = true;
    });
    if (selectedVideos) {
      selectedVideos.forEach((vid) => {
        const videoId = `VIDEO_${vid.uuid}`;
        resourceSelectionStates[videoId] = true;
      });
    }

    const filteredModalResources = [...adHoc, ...nonAdHoc, ...videos];

    return {
      resources: filteredModalResources,
      resourceSelectionStates,
      filteredModalResources,
    };
  };

  resourceAttributes = (res) => {
    const isResourceSelected = this.state.resourceSelectionStates[res.id];

    const checkboxProps = {
      name: isResourceSelected ? 'checkbox-selected' : 'checkbox-unselected',
      className: classNames({
        icon: true,
        'icon--medium': true,
        'icon--green': isResourceSelected,
      }),
    };

    const tagString = res.tags
      .map((tag) => tag.label)
      .filter((tag) => tag !== t('other', i18nOptsTags))
      .sort((a, b) => a.localeCompare(b))
      .join(', ');

    return {
      isRemovable: false,
      isModifiable: false,
      isResourceSelected,
      checkboxProps,
      tagString,
    };
  };

  handleSubmit = () => {
    const { resourceSelectionStates } = this.state;

    const videoSelectionStates = {};
    const resourceOnlySelectionStates = {};

    Object.keys(resourceSelectionStates).forEach((id) => {
      if (id.startsWith('VIDEO_')) {
        videoSelectionStates[id] = resourceSelectionStates[id];
      } else {
        resourceOnlySelectionStates[id] = resourceSelectionStates[id];
      }
    });

    this.props.onSelectResources(resourceOnlySelectionStates, () => {
      if (this.props.onSelectVideos && Object.keys(videoSelectionStates).length > 0) {
        this.props.onSelectVideos(videoSelectionStates);
      }
      this.props.onBack();
    });
  };

  handleFilterModalResources = (input, tags = []) => {
    const isStringIncluded = (parent, child) => parent.toLowerCase().includes(child.toLowerCase());

    const filteredModalResources = this.state.resources.filter(
      (res) =>
        isStringIncluded(res.name, input) &&
        tags.map((tag) => tag.label).every((label) => res.tags.map((tag) => tag.label).includes(label))
    );

    this.setState({ filteredModalResources });
  };

  toggleResourceSelected = (resource) => {
    const newSelectionState = !this.state.resourceSelectionStates[resource.id];
    this.setState((prevState) => ({
      resourceSelectionStates: {
        ...prevState.resourceSelectionStates,
        [resource.id]: newSelectionState,
      },
    }));
  };

  render() {
    return (
      <ExistingResourceForm
        allTags={this.props.allTags}
        resourceAttributes={this.resourceAttributes}
        toggleResourceSelected={this.toggleResourceSelected}
        filteredModalResources={this.state.filteredModalResources}
        onCloseAddResourceModal={this.props.onBack}
        onFilterModalResources={this.handleFilterModalResources}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

LinkResources.propTypes = {
  allTags: PropTypes.array,
  libraryVideos: PropTypes.array,
  onBack: PropTypes.func.isRequired,
  onSelectResources: PropTypes.func.isRequired,
  onSelectVideos: PropTypes.func,
  resources: PropTypes.shape({
    placeResources: PropTypes.array,
    adHocResources: PropTypes.array,
  }),
  selectedResources: PropTypes.array,
  selectedVideos: PropTypes.array,
};

LinkResources.defaultProps = {
  allTags: [],
  libraryVideos: [],
  onSelectVideos: null,
  resources: {
    placeResources: [],
    adHocResources: [],
  },
  selectedResources: [],
  selectedVideos: [],
};

export default LinkResources;
